type State = Record<string, any>;

const validateMandatoryFields = (state: State, mandatoryFields: string[]): Record<string, string> => {
    const errors: Record<string, string> = {};

    mandatoryFields.forEach((field) => {
        if (!state[field] || state[field].toString().trim() === '') {
            errors[field] = `This field is required`;
        }
    });

    return errors;
};

export default validateMandatoryFields;